export default class AlertController {
  /* @ngInject */
  constructor() {
    this.isShowing = true;
    this.isHiding = false;
  }
  closeAlert() {
    this.isShowing = false;
  }
}



// WEBPACK FOOTER //
// ./src/components/alert/alert.controller.js